export enum FilterListboxEnum {
    SELECTION = 'Seleção',
    TO_OMIT = 'Omitir',
    WEB_ONLY = 'Migrados',
    LEGACY_ONLY = 'Não migrados',
    ALL = 'Todos',
}

export type FilterListbox = keyof typeof FilterListboxEnum;
